import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISourceItemData } from '@se/models';
import { ListDataSourceService } from '@se/platform';

@Component({
    selector: 'se-suspend-exam',
    templateUrl: './suspend-exam.component.html',
    styleUrl: './suspend-exam.component.scss',
    standalone: false,
})
export class SuspendExamComponent implements OnChanges {
    @Input() showDialog: boolean = false;
    @Output() formValue: EventEmitter<string> = new EventEmitter<string>();

    datasource: ISourceItemData[] = [];
    form: FormGroup<any>;
    constructor(public listDatasourceService: ListDataSourceService) {
        this.form = new FormGroup({
            suspend: new FormControl('', { validators: [Validators.required] }),
        });
        this.getDatasource();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.showDialog && this.showDialog === false) {
            this.form.reset();
            this.formValue.emit('');
        }
    }

    _onComboSelectionChange(data: any) {
        this.form.controls['suspend'].setValue(data.value);
        this.formValue.emit(this.form.controls['suspend'].value);
    }

    private async getDatasource() {
        this.datasource = await this.listDatasourceService.getLsSuspensionReason();
    }
}
